<template><div><h1 id="einzelanreden" tabindex="-1"><a class="header-anchor" href="#einzelanreden"><span>Einzelanreden</span></a></h1>
<p>Einzelanreden — Definiert die Einzelanreden</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der Steuerung der Einzelanreden in der Anschrift und der Briefanrede. Briefanreden werden im System nicht gespeichert, sondern bei der Datenausgabe aufgrund dieser Steuertabelle generiert. Sämtliche mögliche Kombinationen von Sprache, Adresstyp, Anredecode, Geschlecht und gilt bis Alter werden in dieser Tabelle definiert. Durch die Verwendung von Filtern können weitere Kombinationen definiert werden. Nebst den Standardanreden können mittels Anredesets die Anreden situationsabhängig gesteuert werden. Z.B. bei einem Spendenaufruf könnte die Briefanrede &quot;Lieber Spender&quot; lauten und bei einem Mitgliedermailing &quot;Liebes Mitglied&quot; lauten. Die Briefanrede kann mittels Platzhalter wie Vorname, Nachname und Titel ergänzt werden.</p>
<p>Für die Darstellung von Allianz- und Doppelnamen, in der Anrede- und Briefanrede, sind in funtrade spezielle Regeln hinterlegt.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Anredecodes</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Anrede-Position</dt>
<dd>
<p>Darstellung als Baumstruktur mit Anredeset, Sprache und Anredeposition (wird durch funtrade automatisch vergeben).</p>
</dd>
<dt>Adresstyp</dt>
<dd>
<p>Adresstyp, Privat oder Organisation</p>
</dd>
<dt>Filter</dt>
<dd>
<p>Filter, Auswahl eines Adressfilters</p>
</dd>
<dt>Anredecode</dt>
<dd>
<p>Anredecode, Auswahl aus der Tabelle Anredecodes</p>
</dd>
<dt>Geschlecht</dt>
<dd>
<p>Geschlecht, feminin oder masculin</p>
</dd>
<dt>gilt bis Alter</dt>
<dd>
<p>Eingabe des Alters der Person, bis zu der die definierte Anrede gilt.</p>
</dd>
<dt>Anrede</dt>
<dd>
<p>Anrede für die Anschrift</p>
</dd>
<dt>Briefanrede</dt>
<dd>
<p>Für die Briefanrede können wie im Beispiel aufgeführt, Platzhalter verwendet werden. Folgende sind zulässig:</p>
</dd>
<dd>
<p>&lt;FIRMA&gt;, Firmenname, Organisation</p>
</dd>
<dd>
<p>&lt;VORNAME&gt;, Vorname der Person</p>
</dd>
<dd>
<p>&lt;NACHNAME&gt; oder &lt;DNR_NACHNAME&gt;, Nachname der Person<br>Der Platzhalter &lt;DNR_NACHNAME&gt; wendet die Regeln für die Darstellung von Allianz- und Doppelnamen an (siehe unten).</p>
</dd>
<dd>
<p>&lt;TITEL&gt;, Titel der Person</p>
</dd>
</dl>
<h2 id="zusatzliche-datenfelder-im-editiermodus" tabindex="-1"><a class="header-anchor" href="#zusatzliche-datenfelder-im-editiermodus"><span>Zusätzliche Datenfelder im Editiermodus</span></a></h2>
<dl>
<dt>Anredeset</dt>
<dd>Anredeset, Auswahl aus der Tabelle Anredesets</dd>
<dt>Sprache</dt>
<dd>Sprache, Auswahl aus der Tabelle Sprachen</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="drucken" tabindex="-1"><a class="header-anchor" href="#drucken"><span>Drucken...</span></a></h3>
<p>Druckt die Datensätze als Liste.</p>
<h3 id="regeln-fur-die-darstellung-von-allianz-und-doppelnamen-in-funtrade" tabindex="-1"><a class="header-anchor" href="#regeln-fur-die-darstellung-von-allianz-und-doppelnamen-in-funtrade"><span>Regeln für die Darstellung von Allianz- und Doppelnamen in funtrade</span></a></h3>
<p>Gesetzliche Regelung gem. ZGB Art. 160:</p>
<p>B. Familienname</p>
<ol>
<li>
<p>Der Name des Ehemannes ist der Familienname der Ehegatten.</p>
</li>
<li>
<p>Die Braut kann jedoch gegenüber dem Zivilstandsbeamten erklären, sie wolle ihren bisherigen Namen dem Familiennamen voranstellen.</p>
</li>
<li>
<p>Trägt sie bereits einen solchen Doppelnamen, so kann sie lediglich den ersten Namen voranstellen.</p>
</li>
</ol>
<p>Der Allianzname ist der von einem oder beiden Ehegatten gewählte Name zum Gebrauch im Alltag, der sich vom amtlichen Namen gemäss den Bestimmungen des Schweizerischen Zivilgesetzbuches (ZGB) vom 10. Dezember 1907 unterscheidet. Er wird gebildet aus dem amtlichen Namen sowie aus dem Namen, den einer der Ehegatten vor der Eheschliessung oder als ledig getragen hat. Die beiden Namen werden mit einem Bindestrich verbunden. Der Allianzname hat keine explizite formellrechtliche Grundlage und ist nur in der Schweiz bekannt. Im Gegensatz zum Allianznamen handelt es sich beim Doppelnamen, der durch eine Namensvoranstellung gebildet wird, um einen offiziellen amtlichen Namen gemäss Art. 160 des Schweizerischen Zivilgesetzbuches (ZGB). Der Doppelname schreibt sich im Unterschied zum Allianznamen ohne Bindestrich.</p>
<p>Fall 1: Der Name des Ehemannes wird Familienname, wenn Sie nichts anderes vorsehen (oder umgekehrt: beide tragen den Nachnamen der Ehefrau)</p>
<p>Beide Eheleute heissen nun nach dem Namen des Mannes.</p>
<p>Beispiel: Herr &quot;Müller&quot; heiratet Frau &quot;Weiss&quot;. Sie führen nun den Familiennamen &quot;Müller&quot;.</p>
<p><strong>Tabelle 29. Anzeige der Anrede</strong></p>
<table>
<thead>
<tr>
<th>Vorname/Name</th>
<th>Anrede</th>
<th>Briefanrede</th>
</tr>
</thead>
<tbody>
<tr>
<td>Anna Müller</td>
<td>Frau Anna Müller</td>
<td>Sehr geehrte Frau Müller</td>
</tr>
<tr>
<td>Peter Müller</td>
<td>Herr Peter Müller</td>
<td>Sehr geehrter Herr Müller</td>
</tr>
</tbody>
</table>
<p>Fall 2a: Der Name des Ehemannes wird Familienname. Die Braut kann aber gegenüber dem Zivilstandsbeamten oder der Zivilstandsbeamtin bzw. dem zuständigen Konsulat erklären, dass sie den bisherigen Namen dem Familiennamen voranstellen will.</p>
<p>Beispiel: Herr &quot;Müller&quot; heiratet Frau &quot;Weiss&quot;. Er führt den Namen &quot;Müller&quot;; sie heisst &quot;Weiss Müller&quot;.</p>
<p><strong>Tabelle 30. Anzeige der Anrede</strong></p>
<table>
<thead>
<tr>
<th>Vorname/Name</th>
<th>Anrede</th>
<th>Briefanrede</th>
</tr>
</thead>
<tbody>
<tr>
<td>Anna Weiss Müller</td>
<td>Frau Anna Weiss Müller</td>
<td>Sehr geehrte Frau Weiss</td>
</tr>
<tr>
<td>Peter Müller</td>
<td>Herr Peter Müller</td>
<td>Sehr geehrter Herr Müller</td>
</tr>
</tbody>
</table>
<p>Fall 2b: Der Name der Ehefrau wird Familienname. Der Mann kann aber gegenüber dem Zivilstandsbeamten oder der Zivilstandsbeamtin bzw. dem zuständigen Konsulat erklären, dass er den bisherigen Namen dem Familiennamen voranstellen will.</p>
<p>Beispiel: Herr &quot;Müller&quot; heiratet Frau &quot;Weiss&quot;. Sie führt den Namen &quot;Weiss&quot;; er heisst &quot;Müller Weiss&quot;.</p>
<p><strong>Tabelle 31. Anzeige der Anrede</strong></p>
<table>
<thead>
<tr>
<th>Vorname/Name</th>
<th>Anrede</th>
<th>Briefanrede</th>
</tr>
</thead>
<tbody>
<tr>
<td>Anna Weiss</td>
<td>Frau Anna Weiss</td>
<td>Sehr geehrte Frau Weiss</td>
</tr>
<tr>
<td>Peter Müller Weiss</td>
<td>Herr Peter Müller Weiss</td>
<td>Sehr geehrter Herr Müller</td>
</tr>
</tbody>
</table>
<p>Fall 3a: Es werden die sog. Allianznamen verwendet und die Ehefrau übernimmt den Nachnamen des Ehemannes. Dieser Fall kommt sehr oft vor.</p>
<p>Beispiel: Herr &quot;Müller&quot; heiratet Frau &quot;Weiss&quot;. Sie führt den Namen &quot;Müller-Weiss&quot;; er heisst &quot;Müller&quot; oder auch &quot;Müller-Weiss&quot;.</p>
<p><strong>Tabelle 32. Anzeige der Anrede</strong></p>
<table>
<thead>
<tr>
<th>Vorname/Name</th>
<th>Anrede</th>
<th>Briefanrede</th>
</tr>
</thead>
<tbody>
<tr>
<td>Anna Müller-Weiss</td>
<td>Frau Anna Müller-Weiss</td>
<td>Sehr geehrte Frau Müller</td>
</tr>
<tr>
<td>Peter Müller</td>
<td>Herr Peter Müller</td>
<td>Sehr geehrter Herr Müller</td>
</tr>
<tr>
<td>Peter Müller-Weiss</td>
<td>Herr Peter Müller-Weiss</td>
<td>Sehr geehrter Herr Müller</td>
</tr>
</tbody>
</table>
<p>Fall 3b: Es werden die sog. Allianznamen verwendet und der Ehemann übernimmt den Nachnamen der Ehefrau.</p>
<p>Beispiel: Herr &quot;Müller&quot; heiratet Frau &quot;Weiss&quot;. Sie führt den Namen &quot;Weiss&quot;; er heisst &quot;Weiss-Müller&quot;.</p>
<p><strong>Tabelle 33. Anzeige der Anrede</strong></p>
<table>
<thead>
<tr>
<th>Vorname/Name</th>
<th>Anrede</th>
<th>Briefanrede</th>
</tr>
</thead>
<tbody>
<tr>
<td>Anna Weiss</td>
<td>Frau Anna Weiss</td>
<td>Sehr geehrte Frau Weiss</td>
</tr>
<tr>
<td>Peter Weiss</td>
<td>Herr Peter Weiss</td>
<td>Sehr geehrter Herr Weiss</td>
</tr>
<tr>
<td>Peter Weiss-Müller</td>
<td>Herr Peter Weiss-Müller</td>
<td>Sehr geehrter Herr Weiss</td>
</tr>
</tbody>
</table>
<p><strong>Tabelle 34. Regeln für die Umsetzung in funtrade</strong></p>
<table>
<thead>
<tr>
<th></th>
<th>Partnername vorangestellt</th>
<th>Allianznamen</th>
</tr>
</thead>
<tbody>
<tr>
<td>Erkennung</td>
<td>2 Nachnamen, ohne Bindestrich, 2. Nachname = (1.) Nachname PartnerIn</td>
<td>Bindestrich zwischen Nachnamen</td>
</tr>
<tr>
<td>in Adresse</td>
<td>Anzeige beider Namen</td>
<td>voller Name mit Bindestrich</td>
</tr>
<tr>
<td>Briefanrede</td>
<td>nur 1. Nachname wird angezeigt</td>
<td>nur Name vor dem Bindestrich</td>
</tr>
<tr>
<td>Rahmenbedingungen</td>
<td>Die Adressen müssen einzeln erfasst und über eine Haushaltsbeziehung verbunden sein.</td>
<td></td>
</tr>
<tr>
<td>Bemerkungen</td>
<td>2-teilige Namen werden als Doppelname ausgeschlossen, z.B. &quot;von&quot; (&quot;von Gunten&quot;) oder &quot;de &quot; (&quot;de Weck&quot;) usw.</td>
<td>Die Anrede mit Allianznamen kann erzwungen werden. Dazu muss die Adresse mit einem bestimmten Anredecode (gem. Systemparameter &quot;anredeAllianz&quot;) versehen werden. Bei solchen Adressen wird auch in der Briefanrede der 2. Name mit Bindestrich abgebildet. Dies kann z.B. bei deutschen Staatsbürgern erforderlich sein.</td>
</tr>
</tbody>
</table>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Die Anzeige nach diesen Regeln funktioniert nur mit speziellen Platzhaltern für die Nachnamen in der Anrede- und der <a class="link" href="ft.refdata.tblhhanreden.html" title="Haushaltsanreden">Haushaltsanrede-Tabelle</a>. Die Plazthalter mit Regelbefolgung beginnen mit der Zeichenfolge &quot;DNR_&quot;, z.B. &lt;DNR_NACHNAME_E_F&gt;.</p>
</div>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblhhanreden.html" title="Haushaltsanreden">Haushaltsanreden</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblanredesets.html" title="Anredesets">Anredesets</RouteLink></p>
</div></template>


